import cx from 'clsx';
import type { ReactNode } from 'react';

export interface StickyAsideProps {
  className?: string;
  contentClassName?: string;
  children: ReactNode;
}

export function StickyAside({
  className,
  contentClassName,
  children,
}: StickyAsideProps) {
  return (
    <aside className={className}>
      <div
        className={cx('sticky', contentClassName)}
        style={{
          top: 77,
        }}
      >
        {children}
      </div>
    </aside>
  );
}
